// Delegated handlers also work after a section is refreshed in the theme editor.
(function () {
  function setMenu(open) {
    var nav = document.getElementById('gm-nav');
    var toggle = document.querySelector('.gm-menu-toggle');
    if (nav) nav.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.gm-menu-toggle');
    if (toggle) {
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }
    var link = event.target.closest('a[href]');
    if (link && link.closest('#gm-nav')) setMenu(false);
    if (!event.target.closest('.gm-header')) setMenu(false);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;

    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
    var target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { return; }
    if (!target) return;
    event.preventDefault();
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.dataset.gmSmooth !== 'true';
    target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
    if (!window.Shopify || !window.Shopify.designMode) {
      // Retain Shopify's preview query when following an in-page link.
      history.replaceState(history.state, '', window.location.pathname + window.location.search + url.hash);
    }
  });

  document.addEventListener('keydown', function (event) {
    var nav = document.getElementById('gm-nav');
    if (event.key === 'Escape' && nav && nav.classList.contains('is-open')) {
      setMenu(false);
      var toggle = document.querySelector('.gm-menu-toggle');
      if (toggle) toggle.focus();
    }
  });

  document.addEventListener('shopify:section:load', function () { setMenu(false); });
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target.closest('#gm-nav')) setMenu(true);
  });
})();
